import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function CampaignTickerService() {

    this._updateCampaignTicker = function (evt, data) {
        this._get({
            url: data.url ? data.url : '/kampanjer/earningsticker/earnings?campaigncodeids=' + data.id,
            noShowError: true, // Dont show error messages sent from server on a 500 internal server error
            success: function (data) {
                this.trigger(document, 'ui:campaign:ticker-updated', data);
            }.bind(this)
        }).fail(function () {
            // When connection is wonky and the ajax request fails. Avoid the default error handling
            this.trigger(document, 'ui:campaign:ticker-failure');
        }.bind(this));
    };

    this.after('initialize', function () {
        this.on(document, 'ui:campaign:ticker-on-updating', this._updateCampaignTicker);
    });
}

module.exports = defineComponent.component(CampaignTickerService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/campaign-ticker-service.js